import { THEME_DARK, type Theme, useThemeContext } from "@hoylu/client-common";
import { useSelector } from "react-redux";
import { selectFullscreenWorkspaceId } from "../../state/workspaces/workspaces.selector";

export const useDashboardTheme = (): Theme => {
  const theme = useThemeContext();
  const isFullscreen = useSelector(selectFullscreenWorkspaceId);

  return isFullscreen ? THEME_DARK : theme.theme;
};
